import React, { useState, useCallback } from 'react';
import { Slider } from "@/components/ui/slider";

interface TimeSliderProps {
  data: Array<{
    month: string;
    netCashFlow: number;
    [key: string]: any;
  }>;
  onRangeChange: (startIndex: number, endIndex: number) => void;
  height?: number;
}

/**
 * Custom Range Slider for Time Filtering
 * Simplified implementation using shadcn/ui Slider
 */
export const TimeSlider: React.FC<TimeSliderProps> = ({
  data,
  onRangeChange,
  height = 100
}) => {
  const [range, setRange] = useState([0, data.length - 1]);

  const handleRangeChange = useCallback((newRange: number[]) => {
    setRange(newRange);
    onRangeChange(newRange[0], newRange[1]);
  }, [onRangeChange]);

  if (!data || data.length === 0) {
    return (
      <div className="h-24 bg-muted/20 rounded flex items-center justify-center">
        <span className="text-sm text-muted-foreground">No data available</span>
      </div>
    );
  }

  const startMonth = data[range[0]]?.month || '';
  const endMonth = data[range[1]]?.month || '';

  return (
    <div className="w-full bg-card border rounded-lg p-4 space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h4 className="text-sm font-medium">Time Range Filter</h4>
          <p className="text-xs text-muted-foreground">
            {startMonth} - {endMonth} ({range[1] - range[0] + 1} months)
          </p>
        </div>
        <div className="text-xs text-muted-foreground">
          {data.length} data points
        </div>
      </div>
      
      {/* Range slider */}
      <div className="px-2">
        <Slider
          value={range}
          onValueChange={handleRangeChange}
          max={data.length - 1}
          min={0}
          step={1}
          className="w-full"
        />
      </div>
      
      {/* Range indicators */}
      <div className="flex justify-between text-xs text-muted-foreground">
        <span>{data[0]?.month}</span>
        <span>{data[data.length - 1]?.month}</span>
      </div>
    </div>
  );
};

export default TimeSlider;